import {
  colors,
  Grid,
  media,
  new_typography as typography,
  radius,
  spacing,
} from '@lamimed/pantheon';
import Image from 'next/image';
import styled from 'styled-components';

export const Wrapper = styled(Grid.Wrapper)`
  margin-top: ${spacing.xlarge};

  ${media.greaterThan('tablet')`
    margin-bottom: ${spacing.xxlarge};
  `};
`;

export const DoctorCard = styled.div`
  width: 100%;
  background-color: ${colors.neutral_extra_light};
  border-radius: ${radius.small};
  padding: ${spacing.medium};
`;

export const DoctorProfile = styled.div`
  display: flex;
  margin-bottom: ${spacing.small};
`;

export const DoctorImage = styled(Image)`
  border-radius: ${radius.small};
  flex-shrink: 0;
  margin-right: ${spacing.medium};
`;

export const DoctorDescription = styled.div``;

export const DoctorCredentials = styled.ul`
  padding-left: ${spacing.medium};
  list-style: none;
`;

export const Item = styled.li`
  ${typography.body_text_2}

  color: ${colors.dark};
  display: block;
  margin-bottom: ${spacing.small};
  position: relative;

  &:last-child {
    margin-bottom: 0;
  }

  &::before {
    content: '•';
    position: absolute;
    left: -1.5rem;
    top: 0;
  }

  &:only-child {
    margin-left: -${spacing.medium};
  }

  &:only-child::before {
    content: '';
  }
`;
